var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-popover",
    {
      attrs: { placement: "right", width: "380" },
      model: {
        value: _vm.open,
        callback: function ($$v) {
          _vm.open = $$v
        },
        expression: "open",
      },
    },
    [
      _vm.isRequestForm
        ? _c("div", { staticStyle: { margin: "15px" } }, [
            _c(
              "div",
              [
                _c("div", [
                  _vm._v("\n        Select a verification method\n      "),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c(
                  "el-select",
                  {
                    attrs: { placeholder: "", size: "small" },
                    model: {
                      value: _vm.selected_channel,
                      callback: function ($$v) {
                        _vm.selected_channel = $$v
                      },
                      expression: "selected_channel",
                    },
                  },
                  _vm._l(_vm.channels, function (ch) {
                    return _c("el-option", {
                      key: ch,
                      attrs: { label: ch, value: ch },
                    })
                  }),
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _vm.selected_channel === "SMS"
              ? _c("div", { staticStyle: { margin: "15px" } }, [
                  _c("div", [
                    _c("ul", { staticClass: "authorization__list" }, [
                      _c("li", [
                        _vm._v("\n            Make sure the phone number is "),
                        _c("br"),
                        _vm._v("\n            correct.\n          "),
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.tfa_phone_number) +
                            "\n          "
                        ),
                      ]),
                    ]),
                  ]),
                ])
              : _vm._e(),
          ])
        : _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.posting,
                  expression: "posting",
                },
              ],
              ref: "acceptAuth",
              staticClass: "customer-auth-request-form",
              staticStyle: { margin: "0 17px 0" },
              attrs: {
                "label-position": "top",
                rules: _vm.acceptAuth.rules,
                model: _vm.acceptAuth,
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "code", label: "Verify the code" } },
                [
                  _c("el-input", {
                    attrs: { size: "small", placeholder: "Authorization Code" },
                    nativeOn: {
                      keydown: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        $event.preventDefault()
                        return _vm.submitForm.apply(null, arguments)
                      },
                    },
                    model: {
                      value: _vm.acceptAuth.code,
                      callback: function ($$v) {
                        _vm.$set(_vm.acceptAuth, "code", $$v)
                      },
                      expression: "acceptAuth.code",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
      _vm._v(" "),
      true
        ? _c(
            "el-row",
            _vm._l(_vm.errors, function (error) {
              return _c("el-alert", {
                key: error,
                staticStyle: { "margin-bottom": "15px" },
                attrs: { title: error, type: "error", "show-icon": "" },
              })
            }),
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { "text-align": "right", margin: "0" } },
        [
          _c(
            "el-button",
            {
              attrs: { disabled: _vm.posting, size: "mini", type: "text" },
              on: { click: _vm.closeForm },
            },
            [_vm._v("\n      Cancel\n    ")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: {
                disabled:
                  (_vm.showAcceptCodeForm && _vm.emptyCode) ||
                  (!_vm.showAcceptCodeForm && !_vm.selected_channel),
                type: "primary",
                size: "mini",
              },
              on: { click: _vm.submitForm },
            },
            [
              _c("i", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.posting,
                    expression: "posting",
                  },
                ],
                staticClass: "el-icon-loading",
              }),
              _vm._v(
                "\n      " +
                  _vm._s(_vm.isRequestForm ? "Request" : "Accept") +
                  "\n    "
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-button",
        {
          staticStyle: { padding: "0" },
          attrs: {
            slot: "reference",
            size: "small",
            type: "text",
            disabled: _vm.disabled,
          },
          slot: "reference",
        },
        [
          _vm.$attrs["btn-label"]
            ? _c("span", [_vm._v(" " + _vm._s(_vm.$attrs["btn-label"]))])
            : _vm._t("btn-label"),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }